import socialMediaReducer from './socialMedia';

export * from './asyncAction';
export * from './selectors';
export default socialMediaReducer;
